import {HStack, IconButton, Text} from '@chakra-ui/react';
import {HaliRenderOne} from '@synako/haligator';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {DELAI_MAX_LIVRAISON_CB_JOURS} from 'ff-common';
import {useClient} from '@/haligator-factory';
import {CloseIcon} from '@/components/svg/CloseIcon';
import {CreditCardFastIcon} from '@/components/svg/CreditCardFastIcon';

const STORAGE_KEY = 'paiement-cb-notice-dismissed';

// Bandeau d'information affiché aux clients soumis au paiement CB en ligne pour
// les prévenir que la validation du panier n'est possible que dans une fenêtre
// de livraison limitée (TTL de l'empreinte 1point6).
export const PaiementCBNotice: React.FC = () => {
  const {t} = useTranslation('common');
  const client = useClient();
  const [isDismissed, setIsDismissed] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true',
  );

  const handleClose = (): void => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <HaliRenderOne
      nav={client}
      fallback={() => null}
      render={({data}) => {
        if (!data.doit_payer_en_CB) return null;

        return (
          <HStack
            w='100%'
            bg='blue.main_transparency_10'
            px={{base: '16px', md: '24px'}}
            py='12px'
            alignItems='center'
            justifyContent='center'
            spacing={3}
          >
            <CreditCardFastIcon
              color='blue.main'
              height='22px'
            />
            <Text
              color='blue.main'
              fontSize={{base: 'xs', md: 'sm'}}
              flex='1'
              textAlign='left'
            >
              <Text
                as='span'
                fontWeight={700}
              >
                {t('paiement_cb_notice.titre')}
              </Text>
              {' — '}
              {t('paiement_cb_notice.message', {
                jours: DELAI_MAX_LIVRAISON_CB_JOURS,
              })}
            </Text>
            <IconButton
              aria-label={t('paiement_cb_notice.fermer')}
              icon={
                <CloseIcon
                  color='#0057B8'
                  width='16px'
                  height='16px'
                />
              }
              onClick={handleClose}
              variant='ghost'
              size='sm'
              minW='auto'
              h='auto'
              _hover={{bg: 'transparent', opacity: 0.7}}
            />
          </HStack>
        );
      }}
    />
  );
};
